/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Create_Folder_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to create folder" |
*
* @param {Explorer_Nav_Create_Folder_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_failed_toast = /** @type {((inputs?: Explorer_Nav_Create_Folder_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de creation du dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner konnte nicht erstellt werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile creare la cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось создать папку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo crear la carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建文件夹失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダの作成に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर बनाने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao criar a pasta")
	return /** @type {LocalizedString} */ ("Failed to create folder")
});